import React from 'react'

import { useCustomerPages } from 'features/customers/hooks/useCustomerPages'

import LoadingView from 'components/LoadingView'
import { SimpleTable } from 'components/table'

const config = [
  {
    title: 'Name',
    field: 'name',
  },
  {
    title: 'Starts with',
    field: 'startsWith',
  },
]

const CustomerPages = () => {
  const { data, isLoading } = useCustomerPages()

  return (
    <LoadingView loading={isLoading}>
      <SimpleTable config={config} data={data || []} striped />
    </LoadingView>
  )
}

export default CustomerPages
